import { Component, inject, OnInit } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { ToastModule } from 'primeng/toast';
import { RestoreRouteService } from './core/services/restore-route.service';
import { filter } from 'rxjs';
import { PrimeNG } from 'primeng/config';
import { ColorSystemsService } from './features/config-system/services/color-systems.service';
import { Title } from '@angular/platform-browser';
import { environment } from './core/environments/environment';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ToastModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  title = 'declarabid-private';

  private readonly router = inject(Router);
  private readonly restore = inject(RestoreRouteService);
  private readonly primeng = inject(PrimeNG);
  private readonly colorService = inject(ColorSystemsService);
  private readonly titleService = inject(Title);

  ngOnInit(): void {
    this.titleService.setTitle(environment.appShortName);
    this.colorService.applyCachedColors();
    this._setPrimengTranslation();
    this.colorService.loadAndApplyColors();

    // 1) Si el backend te dejó en '/', intenta restaurar
    this.restore.restoreRouteIfNeeded();

    // 2) Guarda cada navegación para el próximo refresh
    this.router.events
      .pipe(filter((e) => e instanceof NavigationEnd))
      .subscribe(() => this.restore.saveCurrentRoute());
  }

  private _setPrimengTranslation() {
    this.primeng.setTranslation({
      dayNames: [
        'Domingo',
        'Lunes',
        'Martes',
        'Miércoles',
        'Jueves',
        'Viernes',
        'Sábado',
      ],
      dayNamesShort: ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'],
      dayNamesMin: ['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sa'],
      monthNames: [
        'Enero',
        'Febrero',
        'Marzo',
        'Abril',
        'Mayo',
        'Junio',
        'Julio',
        'Agosto',
        'Septiembre',
        'Octubre',
        'Noviembre',
        'Diciembre',
      ],
      monthNamesShort: [
        'Ene',
        'Feb',
        'Mar',
        'Abr',
        'May',
        'Jun',
        'Jul',
        'Ago',
        'Sep',
        'Oct',
        'Nov',
        'Dic',
      ],
      today: 'Hoy',
      clear: 'Limpiar',
    });
  }
}
